import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Upload as UploadAntd,
  Image,
  DatePicker,
  Select,
  Switch,
  Popconfirm,
  Space,
  Tooltip,
  InputNumber,
  Checkbox,
  Typography,
} from "antd";
import PhoneInput from "react-phone-input-2";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment, { period } from "moment";
import apiPath from "../constants/apiPath";
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  FilterFilled,
  PlusOutlined,
  StopOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import PhoneinputField from "../components/PhoneInputField";
import { Upload } from "@aws-sdk/lib-storage";
import lang from "../helper/lang";
import SingleImageUpload from "../components/SingleImageUpload";
import notfound from "../assets/images/not_found.png";
import { Option } from "antd/lib/mentions";
import SuspendIcon from "../assets/images/suspend-main-icon.svg";
import CheckImgIcon from "../assets/images/activee-main-icon.svg";
import { Eye, Pencil, Trash2 } from "lucide-react";
import TransactionViewModal from "../components/TransactionViewModal";

const { RangePicker } = DatePicker;
const { Text } = Typography;

const Search = Input.Search;
const s3Config = {
  region: "us-east-1",
  credentials: {
    accessKeyId: "IJTXH751MBXUWMTWM0SF",
    secretAccessKey: "lfTPRJ2PqAxsp3poTW9YlHktgaL1cFkLup8LidW9",
  },
  endpoint: "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/",
  forcePathStyle: true,
};

const s3Client = new S3Client(s3Config);

let baseURL = apiPath.userSubscriptionManager;

function TransactionManager({ type }) {
  const location = useLocation();
  const lastSearchRef = useRef(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loadingSubscriptions, setLoadingSubscriptions] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [transaction, setTransaction] = useState([]);
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const requestRef = useRef(request);
  useEffect(() => {
    requestRef.current = request;
  }, [request]);
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [record, setRecord] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);
  const [viewCommentModelVisible, setViewCommentModelVisible] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState(null);

  const [originalList, setOriginalList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [benefitsModalVisible, setBenefitsModalVisible] = useState(false);
  const [selectedBenefits, setSelectedBenefits] = useState(null);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [viewTransactionData, setViewTransactionData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [exportFormat, setExportFormat] = useState("XLSX");
  const [exportType, setExportType] = useState("ALL"); // ALL | DATE_RANGE
  const [exportDateRange, setExportDateRange] = useState(null);
  const [exportLimit, setExportLimit] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [isDirectSearch, setIsDirectSearch] = useState(false);
  const requestIdRef = useRef(0);

  const [filters, setFilters] = useState({
    dateRange: null,
    amountRange: null,
    transactionType: null,
    transactionStatus: null,
    // package: null,
  });
  const [filtersVisible, setFiltersVisible] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const txnId = params.get("txn_id");

    if (txnId) {
      setIsDirectSearch(true);
      setSearchText(txnId);

      navigate("/transaction-manager", { replace: true }); // 🔥 clean URL
    }
  }, [location.search]);

  const showModal = (rec) => {
    setRecord(rec);
    setIsModalOpen(true);
  };
  const handleOk = () => {
    handleDelete(record._id);
    setIsModalOpen(false);
  };
  const handleCancel = () => setIsModalOpen(false);

  //------------- Table Columns ------------
  const columns = [
    {
      title: "S. No.",
      key: "serial_no",
      width: 80,
      render: (_, __, index) => {
        const serialNumber =
          (pagination.current - 1) * pagination.pageSize + index + 1;
        return <Text>{serialNumber}</Text>;
      },
    },
    {
      title: "Transaction Ref",
      dataIndex: "reference_number",
      key: "reference_number",
      render: (reference_number) => {
        if (!reference_number) return "N/A";

        const shortId = `${reference_number.slice(0, 8)}...`;

        return (
          <Tooltip title={reference_number}>
            <span style={{ cursor: "pointer", fontFamily: "monospace" }}>
              {shortId}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Transaction Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) =>
        moment(a.created_at).valueOf() - moment(b.created_at).valueOf(),
      render: (date) =>
        date && moment(date).isValid()
          ? moment(date).format("DD MMM YYYY, hh:mm A")
          : "-",
    },
    {
      title: "Sender",
      key: "sender",
      render: (_, record) =>
        record.sender ? (
          <div>
            <div style={{ fontWeight: 500 }}>
              {record.sender.name}
              <Tag color="blue" style={{ marginLeft: 6 }}>
                {record.sender.type}
              </Tag>
            </div>
            <div style={{ fontSize: 12, color: "#888" }}>
              {record.sender.email}
            </div>
          </div>
        ) : "N/A"
    },

    {
      title: "Receiver",
      key: "receiver",
      render: (_, record) =>
        record.receiver ? (
          <div>
            <div style={{ fontWeight: 500 }}>
              {record.receiver.name}
              <Tag color="blue" style={{ marginLeft: 6 }}>
                {record.receiver.type}
              </Tag>
            </div>
            <div style={{ fontSize: 12, color: "#888" }}>
              {record.receiver.email}
            </div>
          </div>
        ) : "N/A"
    },
    // {
    //   title: "Phone Number",
    //   dataIndex: ["user", "mobile"],
    //   render: (_, record) => (
    //     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    //       <span>
    //         {`${record?.user?.country_code}-${record?.user?.mobile}` || "N/A"}
    //       </span>
    //     </div>
    //   ),
    // },
    {
      title: "Transaction Type",
      dataIndex: "service_type",
      render: (type) => (
        <Tag color="blue">{type?.replaceAll("_", " ") || "N/A"}</Tag>
      ),
    },
    // {
    //   title: "Sender and Receiver",
    //   render: (_, record) => (
    //     <Tag color="purple">
    //       {record.sender?.name || "N/A"} → {record.receiver?.name || "N/A"}
    //     </Tag>
    //   )
    // },
    // {
    //   title: "Reason",
    //   render: (_, record) => {
    //     const reason = record?.reason;
    //     const note = record?.note;

    //     return (
    //       <Space direction="vertical" size={0}>
    //         <Text strong>{reason ? reason.replaceAll("_", " ") : "—"}</Text>
    //         {note && (
    //           <Text type="secondary" style={{ fontSize: 12 }}>
    //             {note}
    //           </Text>
    //         )}
    //       </Space>
    //     );
    //   },
    // },
    {
      title: "Payment Info",
      render: (_, record) => {
        if (record.bank) {
          return (
            <div>
              <div>{record.bank.bank_name}</div>
              <div style={{ fontSize: 12, color: "#888" }}>
                ****{record.bank.account_number}
              </div>
            </div>
          );
        }

        return (
          <Tag>
            {record.from_method || "N/A"} → {record.to_method || "N/A"}
          </Tag>
        );
      },
    },
    {
      title: "Amount",
      key: "amount",
      dataIndex: "amount",
      sorter: (a, b) => {
        const priceA = parseFloat(a.amount) || 0;
        const priceB = parseFloat(b.amount) || 0;
        return priceA - priceB;
      },
      render: (_, { amount }) => {
        return <div>NZ${amount ? amount : "No"}</div>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => (a.status || "").localeCompare(b.status || ""),
      render: (status) => (
        <Tag
          color={
            status === "SUCCESS"
              ? "green"
              : status === "PENDING"
                ? "gold"
                : status === "FAILED"
                  ? "red"
                  : "blue"
          }
        >
          {status || "N/A"}
        </Tag>
      ),
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <>
            <Space>
              <Tooltip color="#000" title="View">
                <Button
                  className="button-action-small"
                  onClick={() => handleView(record)}
                  icon={<Eye />}
                />
              </Tooltip>
            </Space>
          </>
        );
      },
    },
  ];

  const showStatusConfirm = (record, toggleStatus) => {
    confirm({
      title:
        record.status === "Active"
          ? "Suspend this plan?"
          : "Activate this plan?",
      content: "Are you sure you want to change the status?",
      okText: "Yes",
      cancelText: "No",
      centered: true,
      okType: record.status === "Active" ? "primary" : "primary",
      onOk() {
        toggleStatus(record);
      },
    });
  };

  const handleExportSubmit = async () => {
    try {
      setExportLoading(true);

      const params = new URLSearchParams();
      params.append("page", 1);
      params.append("limit", 10000); // Fetch all filtered data

      if (searchText) params.append("search", searchText);
      if (filters.transactionType) params.append("transaction_type", filters.transactionType);
      if (filters.transactionStatus) params.append("status", filters.transactionStatus);

      if (filters.amountRange?.[0] !== undefined && filters.amountRange?.[0] !== null) {
        params.append("min_amount", filters.amountRange[0]);
      }
      if (filters.amountRange?.[1] !== undefined && filters.amountRange?.[1] !== null) {
        params.append("max_amount", filters.amountRange[1]);
      }

      if (filters.dateRange?.length === 2) {
        params.append("start_date", filters.dateRange[0].format("YYYY-MM-DD"));
        params.append("end_date", filters.dateRange[1].format("YYYY-MM-DD"));
      }

      const response = await new Promise((resolve, reject) => {
        request({
          url: `/api/admin/transactions?${params.toString()}`,
          method: "GET",
          onSuccess: resolve,
          onError: reject,
        });
      });

      const apiData = response?.data || [];
      if (!apiData.length) {
        ShowToast("No data found for export", Severty.ERROR);
        return;
      }

      const flattened = mapTransactionsView(apiData);
      const fileName = `Transactions_${moment().format("YYYY-MM-DD_HH-mm-ss")}`;

      if (exportFormat === "XLSX") {
        const exportData = flattened.map((item) => ({
          "Transaction ID": item.transaction_id || "N/A",
          "Reference Number": item.reference_number || "N/A",
          "Transaction Date": item.created_at && moment(item.created_at).isValid()
            ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
            : "N/A",
          "Sender Name": item.sender?.name || "N/A",
          "Sender Email": item.sender?.email || "N/A",
          "Receiver Name": item.receiver?.name || "N/A",
          "Receiver Email": item.receiver?.email || "N/A",
          "Service Type": item.service_type || "N/A",
          "From Method": item.from_method || "N/A",
          "To Method": item.to_method || "N/A",
          Amount: `NZ$${item.amount ?? 0}`,
          Status: item.status || "N/A",
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Transactions");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
      } else {
        // PDF Export
        const doc = new jsPDF("l", "pt", "a4");
        const tableColumn = [
          "S.No",
          "Transaction ID",
          "Date",
          "Sender",
          "Receiver",
          "Type",
          "Amount",
          "Status"
        ];
        const tableRows = flattened.map((item, index) => [
          index + 1,
          item.transaction_id || "N/A",
          item.created_at ? moment(item.created_at).format("DD MMM YYYY") : "N/A",
          item.sender?.name || "N/A",
          item.receiver?.name || "N/A",
          item.service_type || "N/A",
          `NZ$${item.amount ?? 0}`,
          item.status || "N/A"
        ]);

        doc.setFontSize(18);
        doc.text("Transaction Report", 40, 40);
        doc.setFontSize(10);
        doc.text(`Generated on: ${moment().format("DD MMM YYYY, HH:mm")}`, 40, 60);

        autoTable(doc, {
          head: [tableColumn],
          body: tableRows,
          startY: 80,
          theme: "grid",
          styles: { fontSize: 8 },
          headStyles: { fillColor: [22, 119, 255] }
        });

        doc.save(`${fileName}.pdf`);
      }

      ShowToast("Export successful", Severty.SUCCESS);
      setExportModalVisible(false);
    } catch (error) {
      console.error(error);
      ShowToast("Export failed", Severty.ERROR);
    } finally {
      setExportLoading(false);
    }
  };

  const uploadFileToS3 = async (file, bucketName) => {
    const key = "realState/admin" + file.name;
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3Client,
      params: params,
    });

    try {
      const data = await upload.done();
      return data;
    } catch (err) {
      throw err;
    }
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const toggleStatus = (record) => {
    const updatedStatus = record.status === "Active" ? "Suspended" : "Active";

    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record._id}`,
      method: "PUT",
      data: { status: updatedStatus },
      onSuccess: (res) => {
        setLoading(false);
        ShowToast("Status updated successfully", Severty.SUCCESS);
        // Update the list with the new status
        setList((prevList) =>
          prevList.map((item) =>
            item._id === record._id ? { ...item, status: updatedStatus } : item,
          ),
        );
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.message || "Failed to update status", Severty.ERROR);
      },
    });
  };

  const handleDelete = (id) => {
    setLoading(true);
    request({
      url: `${baseURL}/${id}`,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setList(list.filter((post) => post._id !== id));
        setRefresh(!refresh);
        ShowToast("Post deleted successfully", Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const applyLocalSearchFilter = (rows, query) => {
    const q = (query || "").trim().toLowerCase();
    if (!q) return rows;

    return rows.filter((item) => {
      const senderName = item?.sender?.full_name?.toLowerCase() || "";
      const senderEmail = item?.sender?.email?.toLowerCase() || "";
      const receiverName = item?.receiver?.full_name?.toLowerCase() || "";
      const receiverEmail = item?.receiver?.email?.toLowerCase() || "";
      const txnId = item?.transaction_id?.toLowerCase() || "";
      const refNo = item?.reference_number?.toLowerCase() || "";

      return (
        senderName.includes(q) ||
        senderEmail.includes(q) ||
        receiverName.includes(q) ||
        receiverEmail.includes(q) ||
        txnId.includes(q) ||
        refNo.includes(q)
      );
    });
  };

  const mapTransactionsView = (transactions) => {
    return transactions.map((txn) => {
      const debitEntry = txn.entries?.find(
        (e) => e.entry_type === "DEBIT"
      );

      const creditEntry = txn.entries?.find(
        (e) => e.entry_type === "CREDIT"
      );

      // 🔥 helper to extract entity
      const getEntity = (entry) => {
        if (!entry) return null;

        if (entry.bank_account) {
          return {
            type: "BANK",
            name: entry.bank_account.bank_name,
            email: "Acct: ****" + entry.bank_account.account_number,
            phone: "N/A",
            image: null,
            balance: 0,
            status: "Active"
          };
        }

        if (!entry.user && !entry.merchant) {
          return {
            type: "SYSTEM",
            name: "DuePay Wallet",
            email: "admin@duepay",
            phone: "N/A",
            image: null,
            balance: 0,
            status: "Active"
          };
        }

        if (entry.user) {
          return {
            type: entry.is_admin_wallet ? "SYSTEM" : "USER",
            name: (entry.user?.first_name ?? "") + " " + (entry.user?.middle_name ?? "") + " " + (entry.user?.last_name ?? ""),
            email: entry.user.email,
            phone: `${entry.user.country_code ?? ""}${entry.user.mobile ?? ""}`,
            image: entry.user.profile_img,
            balance: entry.user.wallet?.reduce((acc, curr) => acc + curr.balance, 0) || 0,
            status: entry.user.status
          };
        }

        if (entry.merchant) {
          const mUser = entry.merchant.user || entry.merchant.users?.find(u => u.is_primary)?.user || entry.merchant.users?.[0]?.user;
          return {
            type: entry.is_admin_wallet ? "SYSTEM" : "MERCHANT",
            name: entry.merchant.business_name,
            email: mUser?.email,
            phone: mUser ? `${mUser.country_code ?? ""}${mUser.mobile ?? ""}` : "N/A",
            image: entry.merchant.business_logo,
            merchant_code: entry.merchant.merchant_code,
            status: entry.merchant.is_active ? "Active" : "Suspended",
            balance: entry.merchant.wallet?.reduce((acc, curr) => acc + curr.balance, 0) || 0
          };
        }

        return null;
      };

      return {
        id: txn.id,
        transaction_id: txn.transaction_id,
        reference_number: txn.reference_number,
        created_at: txn.created_at,
        status: txn.status,
        service_type: txn.service_type,
        amount: txn.amount,

        sender: getEntity(debitEntry),
        receiver: getEntity(creditEntry),

        from_method: debitEntry?.from_method ?? creditEntry?.from_method,
        to_method: creditEntry?.to_method ?? debitEntry?.to_method,

        // 🔥 BANK SUPPORT
        bank:
          txn.method === "BANK" &&
            txn.meta?.bank_name &&
            txn.meta?.account_number
            ? txn.meta
            : null,
        meta: txn.meta,
        original: txn,
      };
    });
  };

  const buildQueryString = (params) => params.toString().replace(/%40/gi, "@");

  const statusChange = (record, reason) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      data: {
        optionalReason: reason || "No Reason",
      },
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  // Handlers
  const handleTableChange = (paginationInfo, filters, sorter) => {
    setPagination((prev) => ({
      ...prev,
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
    }));
  };

  const showConfirm = (record) => {
    let reason = "";
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            <p>Are you sure you want change the status?</p>
            <Input
              placeholder="Enter reason (optional)"
              onChange={(e) => (reason = e.target.value)}
              style={{ marginTop: "10px" }}
            />
          </div>
        ),
        onOk() {
          statusChange(record, reason);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  // Apply filters whenever filters change
  useEffect(() => {
    if (originalList.length > 0) {
      applyFilters();
    }
  }, [filters]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/users-manager/${viewData._id}`);
  }, [visibleView]);

  // ------------- Fetch Transaction -------------
  const fetchTransaction = useCallback(() => {
    if (isDirectSearch && !debouncedSearchText) return;
    const requestKey = JSON.stringify({
      search: debouncedSearchText || "",
      page: pagination.current,
      limit: pagination.pageSize,
      transactionType: filters.transactionType || null,
      transactionStatus: filters.transactionStatus || null,
      amountRange: filters.amountRange || null,
      dateRange: filters.dateRange
        ? filters.dateRange.map((d) => d?.format?.("YYYY-MM-DD") || null)
        : null,
    });
    if (lastSearchRef.current === requestKey) return;
    lastSearchRef.current = requestKey;

    setLoading(true);
    const currentRequestId = ++requestIdRef.current;
    const params = new URLSearchParams();
    if (debouncedSearchText) {
      params.append("search", debouncedSearchText);
    }
    params.append("page", pagination.current);
    params.append("limit", pagination.pageSize);
    if (filters.transactionType) {
      params.append("transaction_type", filters.transactionType);
    }

    if (filters.transactionStatus) {
      params.append("status", filters.transactionStatus);
    }

    if (
      filters.amountRange?.[0] !== undefined &&
      filters.amountRange?.[0] !== null
    ) {
      params.append("min_amount", filters.amountRange[0]);
    }

    if (
      filters.amountRange?.[1] !== undefined &&
      filters.amountRange?.[1] !== null
    ) {
      params.append("max_amount", filters.amountRange[1]);
    }
    // if (filters.package) {
    //   params.append("package_id", filters.package)
    // }
    if (filters.dateRange?.length === 2) {
      try {
        // RangePicker returns dayjs objects which have format method
        params.append("start_date", filters.dateRange[0].format("YYYY-MM-DD"));
        params.append("end_date", filters.dateRange[1].format("YYYY-MM-DD"));
      } catch (e) {
        console.error("Date formatting error:", e);
        // Fallback: try to get date string in different ways
        try {
          if (
            filters.dateRange[0] &&
            typeof filters.dateRange[0].toISOString === "function"
          ) {
            params.append(
              "start_date",
              filters.dateRange[0].toISOString().split("T")[0],
            );
            params.append(
              "end_date",
              filters.dateRange[1].toISOString().split("T")[0],
            );
          } else if (
            filters.dateRange[0] &&
            typeof filters.dateRange[0].toDate === "function"
          ) {
            // If it's a dayjs object with toDate method
            params.append(
              "startDate",
              filters.dateRange[0].toDate().toISOString().split("T")[0],
            );
            params.append(
              "endDate",
              filters.dateRange[1].toDate().toISOString().split("T")[0],
            );
          }
        } catch (fallbackError) {
          console.error("Fallback date formatting also failed:", fallbackError);
        }
      }
    }
    requestRef.current({
      url: `/api/admin/transactions?${buildQueryString(params)}`,
      method: "GET",
      onSuccess: (res) => {
        if (currentRequestId !== requestIdRef.current) return;
        const apiData = res?.data || [];
        const mappedData = mapTransactionsView(apiData);
        const searchedData = applyLocalSearchFilter(
          mappedData,
          debouncedSearchText,
        );
        const finalData =
          debouncedSearchText && searchedData.length === 0 && mappedData.length > 0
            ? mappedData
            : searchedData;
        const paginationData = res?.pagination || {};

        // If backend doesn't support email search and returned empty,
        // fetch a broader dataset and filter locally.
        const isTxnSearch = debouncedSearchText?.length > 8;
        if (debouncedSearchText && finalData.length === 0 && !isTxnSearch) {
          const fallbackParams = new URLSearchParams();
          fallbackParams.append("page", 1);
          fallbackParams.append("limit", 10);

          if (filters.transactionType) {
            fallbackParams.append("transaction_type", filters.transactionType);
          }
          if (filters.transactionStatus) {
            fallbackParams.append("status", filters.transactionStatus);
          }
          if (
            filters.amountRange?.[0] !== undefined &&
            filters.amountRange?.[0] !== null
          ) {
            fallbackParams.append("min_amount", filters.amountRange[0]);
          }
          if (
            filters.amountRange?.[1] !== undefined &&
            filters.amountRange?.[1] !== null
          ) {
            fallbackParams.append("max_amount", filters.amountRange[1]);
          }
          if (filters.dateRange?.length === 2) {
            fallbackParams.append(
              "start_date",
              filters.dateRange[0].format("YYYY-MM-DD"),
            );
            fallbackParams.append(
              "end_date",
              filters.dateRange[1].format("YYYY-MM-DD"),
            );
          }

          requestRef.current({
            url: `/api/admin/transactions?${buildQueryString(fallbackParams)}`,
            method: "GET",
            onSuccess: (fallbackRes) => {
              if (currentRequestId !== requestIdRef.current) return;
              const fallbackApiData = fallbackRes?.data || [];
              const fallbackMapped = mapTransactionsView(fallbackApiData);
              const fallbackSearched = applyLocalSearchFilter(
                fallbackMapped,
                debouncedSearchText,
              );
              setTransaction(fallbackSearched);
              setOriginalList(fallbackSearched);
              setPagination((prev) => ({
                ...prev,
                total: fallbackSearched.length,
                current: 1,
              }));
              setLoading(false);
            },
            onError: () => {
              setTransaction(finalData);
              setOriginalList(finalData);
              setPagination((prev) => ({
                ...prev,
                total:
                  paginationData.totalCount ||
                  paginationData.total ||
                  paginationData.totalDocs ||
                  apiData.length,
              }));
              setLoading(false);
            },
          });
          return;
        }

        setTransaction(finalData);
        setOriginalList(finalData);
        setPagination((prev) => ({
          ...prev,
          total:
            paginationData.totalCount ||
            paginationData.total ||
            paginationData.totalDocs ||
            apiData.length,
        }));
        setLoading(false);
      },
      onError: (error) => {
        setLoading(false);
        setTransaction([]);
        setPagination((prev) => ({ ...prev, total: 0 }));
        ShowToast("Failed to fetch users", Severty.ERROR);
      },
    });
  }, [
    filters,
    debouncedSearchText,
    pagination.current,
    pagination.pageSize,
  ]);

  useEffect(() => {
    if (isDirectSearch && !debouncedSearchText) return;
    fetchTransaction();
  }, [fetchTransaction, isDirectSearch, debouncedSearchText]);

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    setPagination((prev) => ({ ...prev, current: 1 }));
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };

  const handleFilterChange = (filterType, value) => {
    setFilters((prev) => ({ ...prev, [filterType]: value }));
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const clearAllFilters = () => {
    setFilters({
      dateRange: null,
      amountRange: null,
      transactionType: null,
      transactionStatus: null,
      // package: null,
    });
    setFilteredList(originalList);
    setSearchText("");
    setIsDirectSearch(false);
    lastSearchRef.current = null;
    setPagination((prev) => ({ ...prev, current: 1 }));
    ShowToast("All filters cleared successfully", Severty.SUCCESS);
  };

  const applyFilters = () => {
    let filteredData = originalList;

    // period filter
    if (filters.period && filters.period !== "") {
      filteredData = filteredData.filter(
        (item) => item.period === filters.period,
      );
    }

    // Status filter
    if (filters.status && filters.status !== "") {
      filteredData = filteredData.filter(
        (item) => item.status === filters.status,
      );
    }

    setFilteredList(filteredData);
    setList(filteredData);
  };

  const getActiveFiltersCount = () => {
    return Object.values(filters).filter((value) => {
      // null / undefined
      if (value === null || value === undefined) return false;

      // empty string
      if (typeof value === "string" && value.trim() === "") return false;

      // empty array (RangePicker case)
      if (Array.isArray(value) && value.length === 0) return false;

      return true;
    }).length;
  };

  // ---------- Export XLSX File -----------
  const handleExport = () => {
    try {
      console.log("originalList--->", originalList);
      console.log("filteredList--->", filteredList);

      const dataToExport = originalList;

      if (dataToExport.length === 0) {
        ShowToast("No data to export", Severty.ERROR);
        return;
      }

      // Prepare data for export
      const exportData = dataToExport.map((item) => ({
        "Transaction ID": item.transaction_id || "No ID",
        "Transaction Date":
          item.created_at && moment(item.created_at).isValid()
            ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
            : "N/A",
        "Subscription Name": item.package?.name || "No Name",
        "Amount Paid": item.amount_paid || "Not Paid",
        "Payment Status": item.payment_status || "No Status",
        "Subscription ID": item.package.id || "No ID",
        "Subscription Duration": item.package.duration || "No Duration",
        "Subscription Currency": item.package.currency || "No Currency",
        "Customer ID": item.user?.id || "No ID",
        "Customer Name": item.user?.full_name || "No Name",
        "Customer Email": item.user?.email || "No Email",
        "Customer Phone Number": item.user?.mobile
          ? [item.user?.country_code, item.user?.mobile]
            .filter(Boolean)
            .join(" ")
          : "No Mobile",
        // "Customer Username": item.user?.username || "No Username",
        "Customer Status": item.user?.status || "No status",
        "Customer Join Date": item.user?.join_date || "No Date",
      }));

      // Create workbook and worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Auto-fit column widths
      const colWidths = Object.keys(exportData[0]).map((key) => {
        const maxLength = Math.max(
          key.length,
          ...exportData.map((row) =>
            row[key] ? row[key].toString().length : 0,
          ),
        );
        return { wch: maxLength + 2 };
      });

      ws["!cols"] = colWidths;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "User Subscriptions");

      // Generate filename with current date
      const fileName = `User_Subscriptions_${moment().format(
        "YYYY-MM-DD_HH-mm-ss",
      )}.xlsx`;

      // Export file
      XLSX.writeFile(wb, fileName);
      ShowToast("Data exported successfully", Severty.SUCCESS);
    } catch (error) {
      console.error("Export error:", error);
      ShowToast("Failed to export data", Severty.ERROR);
    }
  };

  const handleView = (record) => {
    setViewTransactionData(record);
    setViewModalVisible(true);
  };

  return (
    // <Main>
    <div>
      <div className="tabled">
        <Row>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <span>Transaction Management</span>
                  <Button
                    icon={<FilterFilled />}
                    onClick={() => setFiltersVisible((prev) => !prev)}
                  >
                    {filtersVisible ? "Hide Filters" : "Show Filters"}
                  </Button>
                </div>
              }
            >
              {filtersVisible && (
                <div style={{ marginBottom: 16 }}>
                  <Row gutter={[16, 16]} align="middle" justify="end">
                    <Col span={24} md={6} lg={4} xl={6}>
                      <Search
                        size="large"
                        placeholder="Search by Customer Name / Email"
                        onChange={onSearch}
                        title="Search by Customer Name / Email"
                        value={searchText}
                        onPressEnter={onSearch}
                      />
                    </Col>

                    <Col span={24} md={6} xl={6}>
                      <RangePicker
                        style={{ width: "100%" }}
                        placeholder={[
                          lang("Start_Date") || "Start Date",
                          lang("End_Date") || "End Date",
                        ]}
                        value={filters.dateRange}
                        onChange={(dates) =>
                          handleFilterChange("dateRange", dates)
                        }
                      />
                    </Col>

                    <Col span={24} md={6} lg={2} xl={2}>
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Min"
                        value={filters.amountRange?.[0]}
                        onChange={(value) =>
                          handleFilterChange("amountRange", [
                            value,
                            filters.amountRange?.[1],
                          ])
                        }
                      />
                    </Col>

                    <Col span={24} md={6} lg={2} xl={2}>
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Max"
                        value={filters.amountRange?.[1]}
                        onChange={(value) =>
                          handleFilterChange("amountRange", [
                            filters.amountRange?.[0],
                            value,
                          ])
                        }
                      />
                    </Col>
                    <Col span={24} md={6} lg={4} xl={4}>
                      <Select
                        placeholder="Transaction Type"
                        style={{ width: "100%" }}
                        value={filters.transactionType}
                        onChange={(value) =>
                          handleFilterChange("transactionType", value)
                        }
                        allowClear
                      >
                        <Option value="WALLET_TRANSFER">Wallet Credit</Option>
                        <Option value="BANK_TRANSFER">Bank Transfer</Option>
                        <Option value="ADMIN_CREDIT">Admin Credit</Option>
                        <Option value="WITHDRAWAL">Withdrawal</Option>
                        <Option value="DEPOSIT">Deposit</Option>
                        <Option value="RECHARGE">Recharge</Option>
                        <Option value="CASHBACK">Cashback</Option>
                        <Option value="REFERRAL">Referral</Option>
                      </Select>
                    </Col>
                    <Col span={24} md={6} lg={4} xl={4}>
                      <Select
                        placeholder="Transaction Status"
                        style={{ width: "100%" }}
                        value={filters.transactionStatus}
                        onChange={(value) =>
                          handleFilterChange("transactionStatus", value)
                        }
                        allowClear
                      >
                        <Option value="SUCCESS">Success</Option>
                        <Option value="PENDING">Pending</Option>
                        <Option value="FAILED">Failed</Option>
                      </Select>
                    </Col>
                    <Col>
                      <Button onClick={clearAllFilters}>
                        Clear All Filters
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        icon={<UploadOutlined />}
                        onClick={() => setExportModalVisible(true)}
                        style={{ marginRight: "8px" }}
                      >
                        Export
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
              <div className="table-responsive">
                <Table
                  rowKey={(record) => record._id || record.id}
                  loading={loading}
                  columns={columns}
                  dataSource={transaction}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total || 0,
                    showSizeChanger: true,
                    showQuickJumper: false,
                    showTotal: (total, range) =>
                      `${lang("Showing") || "Showing"} ${range[0]}-${range[1]
                      } ${lang("of") || "of"} ${total} ${lang("transactions") || "transactions"
                      }`,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleTableChange}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal
        title="Delete Post"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Delete"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
        centered
        width={380}
      >
        <div className="select-main-modalss">
          <p>Are you sure you want to delete this post?</p>
        </div>
      </Modal>
      <Modal
        title="Export Transactions"
        open={exportModalVisible}
        onCancel={() => setExportModalVisible(false)}
        onOk={handleExportSubmit}
        okText="Export"
        confirmLoading={exportLoading}
        width={400}
      >
        <div style={{ padding: "10px 0" }}>
          <p style={{ marginBottom: 16, color: "#666" }}>
            The report will be generated based on the currently applied filters in the table.
          </p>
          <Form layout="vertical">
            <Form.Item label="Select Report Format">
              <Select
                value={exportFormat}
                onChange={(val) => setExportFormat(val)}
                style={{ width: "100%" }}
                size="large"
              >
                <Select.Option value="XLSX">Excel Workbook (.xlsx)</Select.Option>
                <Select.Option value="PDF">Portable Document Format (.pdf)</Select.Option>
              </Select>
            </Form.Item>
          </Form>
        </div>
      </Modal>

      {/* View Transaction Modal */}
      <TransactionViewModal
        visible={viewModalVisible}
        onClose={() => setViewModalVisible(false)}
        data={viewTransactionData}
      />
    </div>
    // </Main>
  );
}

export default TransactionManager;
